<template>
	<div id="app">
		<Header></Header>
		<div style="height:122px" :hidden="$route.meta.theme==='dark'"></div>

		<div class="page_top" v-if="$route.meta.pageName">
			<img :src="$route.meta.banner" class="page_banner">
			<div class="page_name">
				<p class="title" :class="isPageAnimate?'animated fadeInRight':''">{{$route.meta.pageName}}</p>
				<!-- <p class="title" :class="{'title_active':isPageAnimate}">{{$route.meta.pageName}}</p> -->
			</div>
		</div>

		<router-view class="limitW"></router-view>

		<Footer :hidden="$route.meta.hideFooter"></Footer>
	</div>
</template>

<script>
import Header from '@C/header'
import Footer from '@C/footer'
import Sidebar from '@C/sidebar.vue'


export default {
	name: 'App',
	components: { Header, Footer, Sidebar },
	data() {
		return {
			pageName:'',
			isPageAnimate: false
		}
	},
	created() {
		
	},
	watch:{
		$route(to,from){
			console.log('watchto',to,from)
			this.isPageAnimate = false

			if(to.name==='CaseRecord') {
				this.pageName = to.params.id + to.meta.pageName
			} else {
				this.pageName = to.meta.pageName
			}
			document.documentElement.scrollTop = 0		// 切换后滚回顶部
		},
	},
	updated() {
		this.isPageAnimate = true
	},
	methods: {

	},
	
}
</script>

<style lang="scss" scoped>
	#app {
		width: 100%;
		height: 100%;
		margin: 0 auto;

		.page_top {
			height: 450px;
			margin-bottom: 100px;
			position: relative;
			.page_banner {
				width: 100%;
				height: 100%;
				object-fit: cover;
				position: absolute;
				top: 0;
				z-index: -1;
			}
			.page_name {
				max-width: 1200px;
				height: 100%;
				margin: 0 auto;
				display: flex;
				flex-direction: column;
				justify-content: center;
				.title {
					font-size: 46px;
					font-family: 'FZCu_Yahei_Jian';
					color: #fff;
				}
				.fadeInRight {
					animation-name: fadeInRight;
				}
				@keyframes fadeInRight {
					0% {
						transform: translate3d(400px, 0, 0);
						opacity: 0;
					}
					100% {
						transform: translate3d(0, 0, 0);
						opacity: 1;
					}
				}
			}
		}
		.limitW {
			max-width: 1200px;
			margin: 0 auto;
		}
	}
	
</style>


// WEBPACK FOOTER //
// src/App.vue